module.exports = __webpack_public_path__ + "img/f41.82d3f863.png";